<app-inline-snackbar
  [type]="snackbarData.type"
  [message]="snackbarData.message"
  (dismiss)="dismiss()"
/>
